export default __webpack_public_path__ + "static/media/Wacky-ducky.a0f044fe.png";